import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function StickyCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const trigger = document.getElementById('dolor-real');
      if (!trigger) return;
      const triggerTop = trigger.getBoundingClientRect().top;
      // Show once the top of the marked section reaches the top of the viewport
      setVisible(triggerTop <= 80);
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    window.addEventListener('resize', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, []);
  const scrollToOfertas = () => {
    const el = document.getElementById('packs') || document.getElementById('ofertas');
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <AnimatePresence data-id="element-268">
      {visible && <motion.div initial={{
      y: '100%'
    }} animate={{
      y: 0
    }} exit={{
      y: '100%'
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 30
    }} className="fixed bottom-0 left-0 right-0 z-50 bg-esbelta-violet text-white shadow-2xl shadow-black/20" data-id="element-269">
          <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between gap-3" data-id="element-270">
            <div className="flex items-center gap-3 min-w-0" data-id="element-271">
              <div className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-white/15 border border-white/25 flex items-center justify-center flex-shrink-0 overflow-hidden" data-id="element-272">
                <img src="https://cdn.magicpatterns.com/uploads/suhcPXB4eKx8m116DtCqhf/WhatsApp_Image_2026-06-15_at_11.29.08_AM.jpg" alt="Logo ESBELTA®" className="w-full h-full object-contain p-0.5" data-id="element-273" />
              </div>
              <div className="min-w-0" data-id="element-274">
                <div className="font-bold text-sm md:text-base leading-tight" data-id="element-275">
                  +10.000 mujeres
                </div>
                <div className="text-[11px] md:text-xs text-white/80 leading-tight truncate" data-id="element-276">
                  ya lo probaron
                </div>
              </div>
            </div>

            <button onClick={scrollToOfertas} className="bg-white text-esbelta-violet font-bold text-sm md:text-base px-5 md:px-8 py-2.5 md:py-3 rounded-xl hover:bg-esbelta-lavender transition-colors flex-shrink-0" data-id="element-277">
              QUIERO MI ESBELTA®
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}